import {
  StrategyGenerator,
  adjustPaymentTable,
  createLedgerEntries,
  preparePaymentTable as generatePaymentTable,
} from "utils/core/strategy.util";
import { StrategyConfigV2, StrategyGenerationClientContext } from "../../dtos/strategy.dto";
import { ApiService } from "api/api.service";

type Config = StrategyConfigV2 & { index?: number };

export const useGenerateStrategy = (context: StrategyGenerationClientContext) => {
  const getGuardRails = (config: Config) => {
    const generator = new StrategyGenerator(context, { ...config, index: 0 });
    return generator.getGuardrails();
  };

  const compile = (config: Config) => {
    const generator = new StrategyGenerator(context, { ...config, index: 0 });
    const strategy = generator.buildStrategy();
    let payment_table = generatePaymentTable(strategy);
    const ledger = createLedgerEntries({ strategy, payment_table });
    payment_table = adjustPaymentTable(payment_table, ledger);
    return { strategy, payment_table, ledger };
  };

  const useAsyncCompile = (config: Config, retainOldState = true) => {
    return ApiService.strategy.useGetCustomConfigurationPreview({
      config,
      context,
      retainOldState,
    });
  };

  return { getGuardRails, compile, asyncCompile: useAsyncCompile };
};
